import './styles/main.css';

import { state, addLayer, startAutosave } from './core/state';
import { makeDefaultLayer } from './core/pipeline';
import { startUrlSync } from './core/url';
import { registerAllGenerators } from './generators';
import { registerAllFilters } from './filters';
import { mountShell } from './ui/shell';
import { enterStudio } from './lib/studioMode';

registerAllGenerators();
registerAllFilters();

const app = document.getElementById('app');
if (!app) throw new Error('PixelLab: missing #app root');

mountShell(app);

// Add a starter stack on first run only.
if (state.peek().layers.length === 0) {
  const solid = makeDefaultLayer('solid', '_');
  const palette = makeDefaultLayer('palette', '_');
  addLayer({ ...solid, params: { color: '#ff5a1f' } });
  addLayer(palette);
}

startAutosave();
startUrlSync();

// Studio is the landing experience — open it as soon as the shell is ready.
// `enterStudio()` ensures a dotgrad layer exists, switches to a window-matched
// resolution, and adds the .studio body class. Users can exit with M / Esc.
enterStudio();
